import api from "../../utils/API";

const getAllFormationsMissionForSelect = () => {
  return api.get(`/gestion/formationsmissionforselect/list`);
};

export {getAllFormationsMissionForSelect};
